import React, { useEffect, useState } from "react";
import FormBuilder from "../../components/formBuilder/FormBuilder";
import formAPI from "../../api/formApi";
import { useParams } from "react-router-dom";

export default function Edit() {
  const [initialForm, setInitialForm] = useState({});
  const [loading, setLoading] = useState(true);

  const location = useParams();
  const id = location.id;

  useEffect(() => {
    fetchFormDetails();
  }, []);

  const fetchFormDetails = async () => {
    try {
      const res = await formAPI.getSingleDetails(id);
      if (res.code === 200) {
        const result = res.data;
        setInitialForm(result);
      }
    } catch (err) {
      console.log("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content">
      <div className="page-header">
        <div className="page-title">
          <h4>Edit New Form</h4>
          <h6>Update customize form with custom field to get your sales.</h6>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h4>Add Form Details</h4>
        </div>
        <div className="card-body profile-body">
          <FormBuilder initialForm={initialForm} formId={initialForm?._id} />
        </div>
      </div>
    </div>
  );
}
